import React, { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import './Header.css';

// Import BOTH logo versions from your assets folder
import logoDark from '../assests/logo-dark.png';
import logoLight from '../assests/logo-light.png'; 

function Header({ activeSection, heroTheme }) {
  const location = useLocation();
  const [isScrolled, setIsScrolled] = useState(false);
  const [currentLogo, setCurrentLogo] = useState(logoLight); // Start with light logo for hero

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  // Corrected logic to determine which logo to show
  useEffect(() => {
    // On pages other than the homepage (like /menu or /login), always use the dark logo.
    if (location.pathname !== '/') {
        setCurrentLogo(logoDark);
        return;
    }
    // On the homepage, adapt based on scroll and theme.
    if (isScrolled) {
      setCurrentLogo(logoDark); 
    } else {
      setCurrentLogo(heroTheme === 'light-theme' ? logoDark : logoLight);
    }
  }, [isScrolled, heroTheme, location.pathname]);

  // When not on the homepage, the header should always be in the 'scrolled' state for a solid background.
  const headerClasses = `header ${isScrolled || location.pathname !== '/' ? 'scrolled' : heroTheme}`;

  return (
    <header className={headerClasses}>
      <div className="header-container">
        <Link to="/" className="logo-container">
          <img src={currentLogo} alt="Degchi Logo" className="logo-img" />
        </Link>
        
        <nav className="main-nav">
          <a href="/#promise" className={activeSection === 'promise' ? 'active' : ''}>Our Promise</a>
          <a href="/#plans" className={activeSection === 'plans' ? 'active' : ''}>Plans</a>
          {/* This is the corrected Link for the Menu page */}
          <Link to="/menu" className={location.pathname === '/menu' ? 'active' : ''}>Menu</Link>
        </nav>

        <div className="header-actions">
            <Link to="/login" className="login-button">
              Login
            </Link>
        </div>
      </div>
    </header>
  );
}

export default Header;

